import moment from 'moment-timezone'
import { IFullStop } from 'types'
import { IDetention } from 'apps/detention-review/utils/types'
import { ShipmentDetentionRequest } from 'apps/fleet-planner/types/apiTypes'
import { ITimeFormats } from 'apps/fleet-planner/utils/userDateTimeSettings'
import { FORMATS } from 'constants/datetime'

export interface IUpdateAccessorialsProps {
  detention: IDetention
  selectedStop?: IFullStop
  calculatedAmount: number
  timeFormats: ITimeFormats
}

export const updateShipmentAccessorials = ({
  calculatedAmount,
  detention,
  selectedStop,
  timeFormats,
}: IUpdateAccessorialsProps): ShipmentDetentionRequest => {
  let detentionUpdates = {}
  if (selectedStop?.status?.timezone) {
    const inputFormat = `${FORMATS.dateFormat} ${timeFormats.stopTimeInput}`
    const startDateTime = moment.tz(
      detention.startDateTime,
      inputFormat,
      selectedStop?.status?.timezone
    )
    const endDateTime = moment.tz(
      detention.endDateTime,
      inputFormat,
      selectedStop?.status?.timezone
    )
    detentionUpdates = {
      startAt: startDateTime.toISOString(),
      endAt: endDateTime.toISOString(),
      amount: String(calculatedAmount),
      additionalInfo: {
        ...detention?.additionalInfo,
        startDateTime: startDateTime.format(FORMATS.datetimeInputFormat) || '',
        endDateTime: endDateTime.format(FORMATS.datetimeInputFormat) || '',
      },
    }
  }

  const accessorialsUpdate = [{ ...detention, ...detentionUpdates }]
  const shipmentUpdates = { shipment: { accessorials: accessorialsUpdate } }
  return shipmentUpdates
}
